export { default } from './LoanActionSavePendingChangesPermissionRow';
